module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring_5@2x.a3ad785.webp";